var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.82533 9.15688L10 13.125H14.6667L9.428 6.57625L13.7867 1.875H12.02L8.60867 5.55375L5.66667 1.875H1L6.00667 8.13438L1.38 13.125H3.14667L6.82533 9.15688ZM10.6667 11.875L3.66667 3.125H5L12 11.875H10.6667Z","fill":"white"}));
}

X.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15","fill":"none"};

module.exports = X;

X.default = X;
